import { getUserId } from "@/src/utils/utils";

import {
  FieldsSection,
  Reference,
  referenceCategories,
  ReferenceCategory,
} from "@/src/data/allTypes";

import { openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";

export function AiFieldSectionForm({
  current,
  currentPrompt,
  onPromptChange,
  onChange,
}: {
  current: FieldsSection;
  currentPrompt: string | null | undefined;
  onPromptChange: (prompt: string) => void;
  onChange: (newValue: FieldsSection) => void;
}) {
  const [prompt, setPrompt] = useState(currentPrompt);
  const [fieldsSection, setFieldsSection] = useState(current);

  return (
    <div className="grid c1 gap10">
      <Input
        name={"Name"}
        type={"text"}
        value={fieldsSection.name}
            onChange={(newValue) => {
          setFieldsSection({
            ...fieldsSection,
            name: newValue,
          });
          onChange(fieldsSection);
        }}
      />
      <Input
        name={"Prompt"}
        type={"textarea"}
        value={prompt}
        rows={30}
        onChange={(newValue) => {
          setPrompt(newValue);
          onPromptChange(newValue);
        }}
      />
    </div>
  );
}

export async function openAiFieldSectionForm({
  current,
  currentPrompt,
  onSave,
}: {
  currentPrompt: string | null | undefined;
  current: FieldsSection;
  onSave: (newValue: FieldsSection) => void;
}) {
  await openDrawer({
    id: "aiFieldSectionDialog",
    title: `Générer un formulaire par IA`,
    additionalClasses: ["big"],
    content: (
      <AiFieldSectionForm
        current={current}
        currentPrompt={currentPrompt}
        onPromptChange={(prompt) => {
          currentPrompt = prompt;
        }}
        onChange={(newValue) => {
          current = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      let inserted = await apiFetch("fieldsSections", "generateAiSection", {
        fieldsSection: current,
        prompt: currentPrompt,
      });
      onSave(inserted);
    },
  });
}
